const Realm = () =>
  import(/* webpackChunkName: "security-realm" */ '@/pages/security/realm/index.vue')
const CreateRealm = () =>
  import(
    /* webpackChunkName: "security-realm" */ '@/pages/security/realm/create.vue'
  )
const EditRealm = () =>
  import(
    /* webpackChunkName: "security-realm" */ '@/pages/security/realm/edit.vue'
  )

export default {
  path: 'realm',
  meta: {
    label: 'realm',
    auth: 'realm'
  },
  component: {
    name: 'Realm',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SecurityRealmReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Realm
    },
    {
      name: 'SecurityCreateRealm',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateRealm
    },
    {
      name: 'SecurityEditRealm',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditRealm,
      props: true
    }
  ]
}
